import SavingListWrapper from "@/modules/savings/SavingListWrapper";

const SavingListPage = () => {
  return <SavingListWrapper />;
};

export default SavingListPage;
